import { render, staticRenderFns } from "./AuctionEdited.vue?vue&type=template&id=6ef31426&scoped=true&"
import script from "./AuctionEdited.vue?vue&type=script&lang=js&"
export * from "./AuctionEdited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef31426",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
